<template>
  <div class="fog-container">
    <!-- <div class="fog-top">
      <div class="fog-top-left">
        <div class="fog-top-title">
          <p>水</p>
          <p>量</p>
          <p>(t)</p>
        </div>
        <div class="fog-top-content">
          <div class="totalItem">
            <div class="first">累积消耗</div>
            <div>
              <div
                class="itemBar"
                v-for="item in 50"
                :key="item"
                :class="[
                  item >
                  countBar(
                    foggunInfo.savePower,
                    foggunInfo.powerConsumption,
                    13
                  )
                    ? 'item-top'
                    : 'item-none',
                ]"
              ></div>
            </div>
            <div class="third">{{ foggunInfo.waterConsumption }}</div>
          </div>
        </div>
      </div>
      <div class="fog-top-right">
        <div class="fog-top-title">
          <p>电</p>
          <p>量</p>
          <p>(kwh)</p>
        </div>
        <div class="fog-top-content">
          <div class="totalItem">
            <div class="first">累积消耗</div>
            <div>
              <div
                class="itemBar"
                v-for="item in 50"
                :key="item"
                :class="[
                  item >
                  countBar(
                    foggunInfo.savePower,
                    foggunInfo.powerConsumption,
                    13
                  )
                    ? 'item-top'
                    : 'item-none',
                ]"
              ></div>
            </div>
            <div class="third">{{ foggunInfo.powerConsumption }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="fog-daterange">
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
      <div class="btns">
        <div @click="search" class="search">搜索</div>
        <div @click="reset" class="reset">重置</div>
      </div>
    </div>
    <div ref="runstopChart" class="fog-head"></div>
    <!-- <div v-show="false" class="fog-bottom">
      <div class="fog-bottom-head">本月运行时长</div>
      <div ref="echart" class="fog-bottom-body"></div>
    </div> -->
  </div>
</template>

<script>
import getBeltOpt from "./chartBar.js";
import { unwarp, getOpt } from "@/utils/tools.js";
import moment from "moment";
import getStopStartLine from "./wpChart.js";
export default {
  name: "FoggunBar",
  props: {
    fogDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    countBar() {
      return function (a, b, c) {
        let count = Math.round((a * c) / (a + b));
        return count;
      };
    },
  },
  watch: {
    fogDetail: {
      handler(n) {
        // this.getFogInfo();
        this.getFogGunStopStartData();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      chart: null,
      chart1: null,
      time: [moment(new Date().getTime() - 1000 * 60 * 60 * 24).format("YYYY-MM-DD HH:mm:ss"), moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss")],
      foggunInfo: {},
    };
  },
  methods: {
    // 搜索
    search() {
      this.getFogGunStopStartData();
    },
    reset() {
      this.time = [moment(new Date().getTime() - 1000 * 60 * 60 * 24).format("YYYY-MM-DD HH:mm:ss"), moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss")];
      this.getFogGunStopStartData();
    },
    // 获取雾炮启停数据
    async getFogGunStopStartData() {
      if (this.chart1) {
        this.chart1.dispose();
        this.chart1 = null;
      }
      let api = CONFIG.requestName + this.$apiOpt.signal_detail;
      try {
        let res = await this.$apiUtils.get(api, {
          startTime: moment(this.time[0]).format("YYYY-MM-DD HH:mm:ss"),
          endTime: moment(this.time[1]).format("YYYY-MM-DD HH:mm:ss"),
          customerId: this.fogDetail.customerId,
          signalNo: this.fogDetail._signalNo
        });
        if (res && res.length) {
          let xData = [];
          let runStopData = [];
          res.length &&
            res.forEach((item) => {
              // if(item.time )
              // xData.push(moment(item.time).format("HH:ss"));
              xData.push(item.time);
              runStopData.push(item.value);
            });
          let option = getStopStartLine(
            this.fogDetail._signalNo,
            xData,
            runStopData
          );
          this.$nextTick(() => {
            this.chart1 = echarts.init(this.$refs.runstopChart);
            unwarp(this.chart1).setOption(option);
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 获取雾炮数据
    async getFogInfo() {
      console.log(this.fogDetail, "fogDetail");
      let waterSprayHistoryUrl = CONFIG.requestName + this.$apiOpt.history;
      // let waterSprayHistoryUrl = 'https://screen.bmetech.com/screen/material/shed/running/history'
      let res = await this.$apiUtils.get(waterSprayHistoryUrl, {
        customerId: this.$store.state.customerId,
        deviceNo: this.fogDetail.deviceNo,
      });
      const { runningTimeList, ...fogObjDetail } = res;
      for (let key in fogObjDetail) {
        if (fogObjDetail[key] === "--") fogObjDetail[key] = 0;
      }
      this.foggunInfo = fogObjDetail;
      this.$nextTick(() => {
        if (runningTimeList) {
          if (this.chart) {
            this.chart.dispose();
            this.chart = null;
          }
          this.chart = echarts.init(this.$refs.echart);
          let echartData = {
            xdata: [],
            ydata: [],
            yName: "运行时长",
          };
          runningTimeList.forEach((i) => {
            echartData.xdata.push(i.date);
            echartData.ydata.push(i.runningTime);
          });
          unwarp(this.chart).setOption(getBeltOpt(echartData));
        }
      });
    },
  },
  unmounted() {
    if (this.chart1) {
      this.chart1.dispose();
      this.chart1 = null;
    }
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
    // this.getFogInfo();
    // this.getFogGunStopStartData();
  },
};
</script>

<style lang="scss" scoped>
.fog {
  &-container {
    width: 100%;
    height: 100%;
    padding: 20px 15px 20px 150px;
  }
  &-daterange {
    height: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 20px;
    .btns {
      width: 300px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search,
      .reset {
        width: 100px;
        height: 40px;
        background-color: #15244d;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }
    }
  }
  &-head {
    height: 240px;
    background: #15244d;
    box-shadow: inset 0px 0px 8px 0px #7ba7ff;
    margin-bottom: 26px;
  }
  &-top {
    height: 240px;
    display: flex;
    background: #15244d;
    box-shadow: inset 0px 0px 8px 0px #7ba7ff;
    margin-bottom: 26px;
    align-items: center;
    &-left,
    &-right {
      flex: 1;
      display: flex;
      padding: 10px;
      align-items: center;
    }
    &-title {
      width: 80px;
      height: 220px;
      background-color: #171f46;
      display: flex;
      font-size: 35px;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      margin-right: 20px;
    }
    &-content {
      width: 85%;
      height: 220px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
  &-bottom {
    height: 264px;
    &-head {
      height: 34px;
      line-height: 34px;
      font-size: 24px;
      padding: 0 20px;
    }
    &-body {
      height: calc(100% - 34px);
      // background: rgba(21, 36, 77, 0.9);
    }
  }
}
.first,
.third {
  background-color: #055262;
}
.first-bottom,
.third-bottom {
  background-color: #196ebe;
}
.item-top {
  background-color: #33ddff;
  margin: 2px;
  border-radius: 2px;
}
.item-bottom {
  background-color: #3296e8;
  margin: 2px;
  border-radius: 2px;
}
.item-none {
  background-color: #000;
  margin: 2px;
  border-radius: 2px;
}
</style>
<style lang="scss" scoped>
.totalItem {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
}
.totalItem div {
  text-align: center;
}
.totalItem > div:nth-child(1) {
  width: 20%;
  height: 100%;
  line-height: 80px;
  font-size: 20px;
}
.totalItem > div:nth-child(2) {
  width: 70%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.itemBar {
  flex: 1;
  width: 7px;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}
.totalItem > div:nth-child(3) {
  width: 10%;
  height: 100%;
  line-height: 80px;
  color: #f6ff46;
  font-size: 30px;
  text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.32);
  font-family: "number";
}
.itemBarYellow {
  background-image: url("./img/fgitem1.png");
}
.itemBarNoYellow {
  background-image: url("./img/fgitem11.png");
}
.itemBarBlue {
  background-image: url("./img/fgitem2.png");
}
.itemBarNoBlue {
  background-image: url("./img/fgitem22.png");
}
:deep(.el-range-editor.el-input__inner) {
  background-color: #15244d;
}
:deep(.el-range-editor .el-range-input) {
  background: #15244d;
  color: #fff;
}
</style>